import { LoadingButton, Stack } from "@altimateai/lego";
import { Alert, Card, CardContent, CardFooter } from "@altimateai/lego";
import ChecksInput from "./ChecksInput";
import {
  ProjectGovernorCheckTypes,
  ProjectGovernorCheckValidateResponse,
  ProjectGovernorCheckConfirmationResponse,
} from "./types";
import { useState } from "react";
import { ApiHelper, useMutation } from "../../api/index";
import { TeamMateComponentProps } from "../types";
import { Button } from "@altimateai/lego";

interface Props extends TeamMateComponentProps<ProjectGovernorCheckConfirmationResponse> {}

const ProjectGovernorForm = ({ onClose = () => {} }: Props) => {
  const [projectGovernorValidateResponse, setProjectGovernorValidateResponse] = useState<
    ProjectGovernorCheckValidateResponse & {
      type: ProjectGovernorCheckTypes;
    }
  >();

  const onSuccess = (
    data: ProjectGovernorCheckValidateResponse,
    type: ProjectGovernorCheckTypes
  ) => {
    setProjectGovernorValidateResponse({ ...data, type });
  };

  const {
    mutate,
    error,
    loading: isSaving,
    data,
  } = useMutation<void, ProjectGovernorCheckConfirmationResponse>({
    queryFn: () => {
      return ApiHelper.post<ProjectGovernorCheckConfirmationResponse>(`project_governance/check`, {
        ...projectGovernorValidateResponse,
      });
    },
  });

  if (data) {
    return (
      <Alert>
        Project governance check saved successfully{" "}
        <Button variant="secondary" onClick={() => onClose(data)}>
          View
        </Button>
      </Alert>
    );
  }

  return (
    <Stack direction="column">
      <p className="al-m-0">
        Here, you can provide instructions in natural language to create project governance checks
      </p>

      <ChecksInput onSuccess={onSuccess} onCancel={onClose} />

      {projectGovernorValidateResponse ? (
        <Card className="al-mt-4">
          <CardContent className="al-pt-4">
            <p>Please validate the following check: </p>
            <p>{projectGovernorValidateResponse.name}</p>
            <p>{projectGovernorValidateResponse.description}</p>
            <p>Type: {projectGovernorValidateResponse.type}</p>
            {error && <div className="text-danger">{error.message}</div>}
          </CardContent>
          <CardFooter className="al-mt-2 border-0">
            <Stack justify="end" className="al-gap-2">
              <LoadingButton loading={isSaving} onClick={() => mutate()} color="primary">
                Save
              </LoadingButton>
            </Stack>
          </CardFooter>
        </Card>
      ) : null}
    </Stack>
  );
};

export default ProjectGovernorForm;
